import React, { createContext, useContext, useEffect } from 'react';
import metaPixelService from '../services/metaPixelService';
import { useDropshipper } from './DropshipperContext';

const MetaPixelContext = createContext(null);

export const useMetaPixel = () => {
  const ctx = useContext(MetaPixelContext);
  if (!ctx) {
    throw new Error('useMetaPixel must be used inside <MetaPixelProvider>');
  }
  return ctx;
};

export const MetaPixelProvider = ({ children }) => {
  const { metaPixelId } = useDropshipper();

  useEffect(() => {
    if (metaPixelId) {
      metaPixelService.registerPixel(metaPixelId);
    }
  }, [metaPixelId]);

  const value = {
    pixelId: metaPixelId,
    isEnabled: !!metaPixelId,
    trackPageView: () => metaPixelService.trackPageView(metaPixelId),
    trackViewContent: (product) => metaPixelService.trackViewContent(metaPixelId, product),
    trackInitiateCheckout: (items, total) =>
      metaPixelService.trackInitiateCheckout(metaPixelId, items, total),
    trackPurchase: (orderData) => metaPixelService.trackPurchase(metaPixelId, orderData),
    generateEventId: () => metaPixelService.generateEventId(),
    getStatus: () => metaPixelService.getStatus(),
  };

  return <MetaPixelContext.Provider value={value}>{children}</MetaPixelContext.Provider>;
};
